import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {
  
  public user_list = [];
  public columns = [];
  public temp = [];
  message = null;
  class = null;

  constructor(private router: Router, private api: ApiService, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) {
  }

  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      name: {
        title: 'Name',
      },
      email: {
        title: 'Email'
      },
      contact: {
        title: 'Contact'
      },
      role: {
        title: 'Role'
      },
      _id: {
        title:'Edit',
        type:'html',
        valuePrepareFunction:(cell,row)=>{
          return `<a href="users/edit/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; `
        },
        filter:false
      },
    },
  };

  ngOnInit() {
    this.http.get<any>(`${environment.apiUrl}/admin/`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.user_list = data.data;
          this.columns = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  delete(id) {
    if(confirm("Are you sure to deactivate account? ")){
    var data1 = {
      "active" : '0',
      "_id" : id,
    };
    this.http.put<any>(`${environment.apiUrl}/admin/`, data1, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn-primary rounded px-1 py-1';
          return
        }else{
          this.message = 'Successfully Deactivated Profile';
          this.class = 'btn-success rounded px-1 py-1';
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

  activate(id, activestatus) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to deactivate account? ")){
    var data1 = {
      "active" : '1',
      "_id" : id,
    };
    this.http.put<any>(`${environment.apiUrl}/admin/`, data1, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn-primary rounded px-1 py-1';
          return 0;
        }else{
          this.message = 'Successfully Activated Profile';
          this.class = 'btn-success rounded px-1 py-1';
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

  deleteRecord(event){
    alert(event.data._id);
  }

}

